import React, { useState } from 'react';
import { ProductTypes } from '../../types/product/product';
import ProductCard from '../../components/molecules/ProductItem/ProductCard';
import { useDispatch, useSelector } from 'react-redux';
import { selectProductDisplay } from '../../store/selectors/ui.selectors';
import ProductList from '../../components/molecules/ProductItem/ProductList/index';
import useStyle from './productsLoop.style';
import { updatePanier as updatePanierAction } from '../../store/actions/panier.actions';
import { multiply, toNumber } from '../../helpers/number/sanitizeCalul';
import { getFilteredProducts } from '../../store/selectors/productFilter.selectors';
import { ContainerTwoThirds } from 'components/layouts/ContainerTwoThirds';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import emojis from 'theme/emoji';
import { Panier } from 'components/organisms/Panier';
import toast from 'react-hot-toast';

interface ProductsLoopProps {
  onClickNavigate: (idProduit: ProductTypes['id']) => () => void;
  isPublicShop?: boolean;
}

const ProductsLoop = ({
  onClickNavigate,
  isPublicShop = false
}: ProductsLoopProps) => {
  const [productQuantity, setProductQuantity] = useState<number>(1);
  const { filteredProducts } = useSelector(getFilteredProducts);
  const display = useSelector(selectProductDisplay);
  const dispatch = useDispatch();
  const classes = useStyle({ isPublicShop });
  const hasProducts = filteredProducts && filteredProducts.length > 0;

  const onAddToCart = (product: ProductTypes) => () => {
    dispatch(
      updatePanierAction({
        produit: {
          ...product,
          media: [{ url: product?.media[0]?.url }]
        },
        quantite: toNumber(productQuantity),
        totalLine: multiply(product.ttcPrice)(productQuantity)
      })
    );
    toast.success(productQuantity + ' ' + product.name + ' ajouté au panier');
    setProductQuantity(1);
  };

  if (display === 'Mosaique')
    return (
      <div className={classes.rootMosaique}>
        <div className={classes.productContainer}>
          {hasProducts ? (
            filteredProducts.map(product => (
              <div className={classes.productCard} key={product.id}>
                <ProductCard
                  onClickNavigate={onClickNavigate(product.id)}
                  onAddToCart={onAddToCart(product)}
                  setProductQuantity={setProductQuantity}
                  product={product}
                  isPublicShop={isPublicShop}
                />
              </div>
            ))
          ) : (
            <div className={classes.noproduct}>
              <FeatureContainer>
                <p>
                  Pas de produits trouvés{' '}
                  <span role="img" aria-label="emojis_frustré">
                    😖
                  </span>
                </p>
              </FeatureContainer>
            </div>
          )}
        </div>
      </div>
    );
  if (display === 'List')
    return (
      <div className={classes.root}>
        <ContainerTwoThirds
          col1={
            hasProducts ? (
              filteredProducts.map(product => (
                <div key={product.id} className={classes.item}>
                  <ProductList
                    onClickNavigate={onClickNavigate(product.id)}
                    onAddToCart={onAddToCart(product)}
                    setProductQuantity={setProductQuantity}
                    product={product}
                    isPublicShop={isPublicShop}
                  />
                </div>
              ))
            ) : (
              <div className={classes.noproduct}>
                <FeatureContainer>
                  <p>
                    Pas de produits trouvés{' '}
                    <span role="img" aria-label="emojis_frustré">
                      😖
                    </span>
                  </p>
                </FeatureContainer>
              </div>
            )
          }
          col2={
            <div className={classes.rootPanier}>
              <HeaderText text="Mon Panier" emoji={emojis['ShoppingCart']} />
              <Panier />
            </div>
          }
        />
      </div>
    );
};

export default ProductsLoop;
